import { useState, useRef } from "react";
import UserCardModal from "../../components/modals/UserCardModal";

export default function UserCard({ user }) {
  const [open, setOpen] = useState(false);
  const cancelButtonRef = useRef(null);

  return (
    <div className="h-15">
      <div className="flex items-center cursor-pointer">
        <img
          className="w-12 h-12 rounded-full mr-4"
          src={user?.profileImage}
          alt={user?.username}
        />
        <div className="text-xs w-40">
          <div className="text-gray-900 font-bold name">{user?.fullName}</div>
          <div className="text-green-800" onClick={() => setOpen(true)}>
            View profile
          </div>
        </div>
      </div>
      <UserCardModal
        user={user}
        open={open}
        setOpen={setOpen}
        cancelButtonRef={cancelButtonRef}
      />
    </div>
  );
}
